module.exports = __webpack_public_path__ + "static/img/5.2979522.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/5.png
// module id = y3A0
// module chunks = 0